// hook/request.tsx - COMPLETE WORKING VERSION
import { useEffect } from "react";
import axios from "axios";
import { useAppState } from "./app-state";
import tokenService from "../services/tokenService";
import authService from "../services/authService";

const apiClient = axios.create({
  headers: {
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": "69420",
  },
  timeout: 90000,
});

apiClient.interceptors.request.use(
  async (config) => {
    try {
      // Skip token for auth endpoints
      if (
        config.url?.includes("/auth/verify") ||
        config.url?.includes("/auth/refresh")
      ) {
        if (config.url) {
          config.headers["X-Target-Service"] =
            tokenService.getTargetServiceHeader(config.url);
        }
        return config;
      }

      // Get current token (this will handle refresh automatically)
      const token = await tokenService.getCurrentToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      // Set service header
      if (config.url) {
        config.headers["X-Target-Service"] =
          tokenService.getTargetServiceHeader(config.url);
      }
    } catch (error) {
      console.error("Request interceptor error:", error);
    }

    return config;
  },
  (error) => Promise.reject(error)
);

const makeAPIRequest = (options: any) => {
  return apiClient(options);
};

const AxiosInterceptor = ({ children }: any) => {
  const { onShowSnackbar }: any = useAppState();

  useEffect(() => {
    const resInterceptor = (response: any) => response;

    const errInterceptor = async (error: any) => {
      if (error.response?.status === 401) {
        console.error("Unauthorized - clearing token");
        await tokenService.clearStoredToken();
        await authService.logout();
        window.location.href = "/about-eira";
      } else if (error.response?.status === 500) {
        onShowSnackbar(error?.response?.data?.error || "Server error", "error");
      }

      return Promise.reject(error);
    };

    const interceptor = apiClient.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    return () => apiClient.interceptors.response.eject(interceptor);
  }, [onShowSnackbar]);

  return children;
};

export { makeAPIRequest, AxiosInterceptor };
